<template>
  <div id="contenedor-tablero-resumen-auditorias">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Ente</th>
            <th align="center">Ejercicio</th>
            <th>Auditoria</th>
            <th align="center">Observaciones</th>
            <th>Solventadas</th>
            <th>% Solventado</th>
            <th>Por Solventar</th>
            <th>Por Responder</th>
            <th>Desglose</th>
            <th>D. Solventado</th>
            <th>D. Por Solventar</th>
            <th>D. Enviado a Ente</th>
            <th>D. Por Enviar</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(enteFiscalizador, index) in mixGetEntesFiscalizadores">
            <template>
              <tr :key="`enteFiscalizador-${index}`" class="font-weight-bold grey lighten-2">
                <td>
                  {{ enteFiscalizador.nombre }}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </template>
            <template v-for="auditoria in enteFiscalizador.auditorias">
              <template>
                <tr
                  :key="`auditoria-${auditoria.nombre}`"
                  class=" grey lighten-5">
                  <td></td>
                  <td>
                    {{ auditoria.ejercicio }}
                  </td>
                  <td> {{ auditoria.nombre }} </td>
                  <td align="center">
                    <v-chip>
                      {{ auditoria.cantidadObservaciones}}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip color="verde1">
                      {{ auditoria.cantidadSolventadas }}
                    </v-chip>
                  </td>
                  <td align="center">
                    {{ auditoria.porcentajeSolventadas }} %
                  </td>
                  <td align="center">
                    <v-chip color="azul1">
                    {{ auditoria.cantidadPorSolventar }}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip color="naranja2">
                    {{ auditoria.cantidadPorResponder }}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip>
                    {{ auditoria.desglose }}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip>
                    {{ auditoria.desgloseSolventado }}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip>
                    {{ auditoria.desglosePorSolventar }}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip>
                    {{ auditoria.desgloseEnviadoEnte }}
                    </v-chip>
                  </td>
                  <td align="center">
                    <v-chip>
                    {{ auditoria.desglosePorEnviar }}
                    </v-chip>
                  </td>
                </tr>
              </template>
            </template>
            <template>
              <tr :key="`enteFiscalizador-total-${index}`" class="font-weight-bold grey lighten-4">
                <td></td>
                <td></td>
                <td align="right">SUBTOTAL</td>
                <td align="center">
                  {{ enteFiscalizador.totalObservaciones }}
                </td>
                <td align="center">
                  {{ enteFiscalizador.totalSolventadas }}
                </td>
                <td align="center">
                  {{ $numberRound((enteFiscalizador.totalSolventadas * 100)
                    / enteFiscalizador.totalObservaciones) }} %
                </td>
                <td align="center">
                  {{ enteFiscalizador.totalPorSolventar }}
                </td>
                <td align="center">
                  {{ enteFiscalizador.totalPorResponder }}
                </td>
                <td align="center">
                  {{ enteFiscalizador.totalDesglose }}
                </td><td align="center">
                  {{ enteFiscalizador.totalDesgloseSolventado }}
                </td><td align="center">
                  {{ enteFiscalizador.totalDesglosePorSolventar }}
                </td><td align="center">
                  {{ enteFiscalizador.totalDesgloseEnviadoEnte }}
                </td><td align="center">
                  {{ enteFiscalizador.totalDesglosePorEnviar }}
                </td>

              </tr>
            </template>
          </template>
        </tbody>
        <tfoot class="font-weight-bold selected">
          <tr>
            <td></td>
            <td></td>
            <td align="right">TOTAL</td>
            <td align="center">{{ mixGetTotalesObservaciones.totalObservaciones }}</td>
            <td align="center">{{ mixGetTotalesObservaciones.totalSolventadas }}</td>
            <td align="center">
              {{ $numberRound(mixGetTotalesObservaciones.totalPorcentajeSolventado) }} %
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalPorSolventar }}
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalPorResponder }}
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalDesglose }}
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalDesgloseSolventado }}
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalDesglosePorSolventar }}
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalDesgloseEnviadoEnte }}
            </td>
            <td align="center">
              {{ mixGetTotalesObservaciones.totalDesglosePorEnviar }}
            </td>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import mixTablerosObservaciones from './mixTablerosObservaciones';

export default {
  name: 'TableroResumenAuditorias',
  mixins: [mixTablerosObservaciones],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },

};
</script>

<style lang="scss" scoped></style>
